import { css } from 'styled-components';
import { IAddressStyledProps } from './models';

export const SAddressContainer = ({ theme }: IAddressStyledProps) => {
  return css`
    min-width: 100%;
    .menu-list {
      position: absolute;
      width: 100%;
      z-index: 1;
      box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
      box-sizing: border-box;
      color: ${theme.colors.autocompleteSuggestion};
      background-color: white;
    }
    .active-suggestion,
    .suggestion-container:hover {
      background-color: ${theme.colors.brightBlue95};
    }

    .suggestion-container {
      padding: ${theme.spacing.smallMedium}px;
    }

    .suggestion-container,
    .suggestion-text-container,
    .suggestion-main,
    .suggestion-secondary {
      display: flex;
    }

    .suggestion-text-container {
      flex-direction: column;
    }

    .suggestion-text-main {
      display: flex;
      white-space: pre;
      font-size: ${theme.font.size.smallMedium};
      line-height: 1.5rem;
      margin-bottom: ${theme.spacing.small}px;
    }

    .location-icon {
      vertical-align: top;
      padding: 2px;
    }
    .matched-pattern {
      font-weight: ${theme.font.weight.bold};
      color: ${theme.colors.autocompleteSuggestionMatched};
    }

    .suggestion-secondary {
      font-size: ${theme.font.size.small};
      line-height: 1rem;
    }
  `;
};
